import { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { BiShoppingBag, BiMenu, BiSolidCategory } from "react-icons/bi";
import {
  MdInventory,
  MdDashboard,
  MdProductionQuantityLimits,
} from "react-icons/md";
import { IoIosLogOut } from "react-icons/io";
import { TiUser } from "react-icons/ti";
import { GrUserWorker } from "react-icons/gr";
import { RiFlowerLine } from "react-icons/ri";

const SIDEBAR_ITEMS = [
  {
    name: "Бүлэг",
    icon: BiSolidCategory,
    color: "#3B8FF3",
    path: "/category",
  },
  // {
  //   name: "Эвент",
  //   icon: MdDashboard,
  //   color: "#69c3a3",
  //   path: "/special",
  // },
  {
    name: "Бүтээгдэхүүн",
    icon: MdProductionQuantityLimits,
    color: "#F3797E",
    path: "/product",
  },
  {
    name: "Ажилтан",
    icon: GrUserWorker,
    color: "#6366f1",
    path: "/employ",
  },
  // {
  //   name: "Хэрэглэгч",
  //   icon: TiUser,
  //   color: "#FFC100",
  //   path: "/users",
  // },
  {
    name: "Захиалга",
    icon: BiShoppingBag,
    color: "#03A9F",
    path: "/orders",
  },
  {
    name: "Бараа",
    icon: MdInventory,
    color: "#F59E0B",
    path: "/inventory",
  },
  {
    name: "Цэцэг",
    icon: RiFlowerLine,
    color: "#FFC0CB",
    path: "/flower",
  },
];

const Sidebar = ({ check }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const user = JSON.parse(window.localStorage.getItem('ts_user'));

  useEffect(() => {
    if (!user) {
      navigate('/login')
    }
  }, [user])

  return (
    <div className="fixed">
      <div
        className={`fixed  transition-all duration-300 ease-in-out flex-shrink-0 ${isSidebarOpen ? "w-64" : "w-20"
          }`}
      >
        <div
          className={
            check
              ? "h-screen bg-sky-950 backdrop-blur-md p-4 flex flex-col border-r border-gray-700"
              : "h-screen text-zinc-800 bg-[#fff] p-4 flex flex-col border-r border-gray-300"
          }
        >
          <div className="flex items-center mb-6 cursor-pointer">
            <img
              className="w-12 h-12 rounded-full border-2 border-gray-600"
              src="profile.jpg"
              alt="Profile"
            />
            {isSidebarOpen && (
              <div className="ml-4">
                <p className="text-zinc-800 text-sm font-medium">Цэцэг төв</p>
                <p className="text-gray-400 text-xs">Tsetsegtov@gmail.mn</p>
              </div>
            )}
          </div>

          {/* Toggle Button */}
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="p-2 rounded-full hover:bg-gray-700 hover:text-white  transition-colors max-w-fit mb-4"
          >
            <BiMenu size={24} />
          </button>

          <nav className="flex-grow mt-4">
            {SIDEBAR_ITEMS.map((item) => (
              <Link key={item.path} to={item.path}>
                <div className="flex items-center p-3 text-sm font-medium rounded-lg  hover:bg-gray-700 hover:text-white transition-colors mb-2">
                  <item.icon
                    size={20}
                    style={{ color: item.color, minWidth: "20px" }}
                  />
                  {isSidebarOpen && (
                    <span className="ml-4 whitespace-nowrap">{item.name}</span>
                  )}
                </div>
              </Link>
            ))}
          </nav>

          <button
            onClick={() => {
              window.localStorage.removeItem('ts_user');
              window.location.reload(false);
            }}
            className={`"mt-auto p-2 border border-gray-600 rounded-full hover:bg-red-600 transition-colors  hover:text-white flex items-center "${check ? "text-gray-300" : "text-gray-800"
              }`}
          >
            <IoIosLogOut size={20} className="mx-2" />
            {isSidebarOpen && <span >Гарах</span>}
          </button>
        </div>
      </div>

      <div>
        <Outlet />
      </div>
    </div>

  );
};

export default Sidebar;
